import React from 'react';
import { MODULE_META, defaultT } from './constants.js';

/**
 * ModuleToggle — Eine Modul-Karte mit Switch fuer LicenseEditor.
 */
export default function ModuleToggle({
  moduleKey, value, onChange, disabled = false, moduleMeta, t = defaultT,
}) {
  const metaSource = moduleMeta || MODULE_META;
  const meta = metaSource[moduleKey] || { icon: '•', label: moduleKey, description: '' };
  const label       = t(`shared.license.modules.${moduleKey}`, meta.label);
  const description = t(`shared.license.module_descriptions.${moduleKey}`, meta.description);

  return (
    <div
      onClick={() => !disabled && onChange(moduleKey, !value)}
      style={{
        display: 'flex', alignItems: 'flex-start', gap: 12, padding: '12px 14px',
        borderRadius: 10, border: `1.5px solid ${value ? '#10b98160' : 'var(--border)'}`,
        background: value ? '#f0fdf4' : 'var(--bg2)',
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.6 : 1,
        transition: 'all 0.15s',
      }}>
      <span style={{ fontSize: 20, marginTop: 1 }}>{meta.icon}</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)' }}>{label}</div>
        <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 2, lineHeight: 1.4 }}>{description}</div>
      </div>
      <div style={{
        width: 36, height: 20, borderRadius: 10, position: 'relative', flexShrink: 0, marginTop: 2,
        background: value ? '#10b981' : '#d1d5db', transition: 'background 0.2s',
      }}>
        <div style={{
          position: 'absolute', top: 2, left: value ? 18 : 2, width: 16, height: 16,
          borderRadius: 8, background: '#fff', transition: 'left 0.2s',
          boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
        }} />
      </div>
    </div>
  );
}
